// extracted by mini-css-extract-plugin
module.exports = {"wire":"top-christmas_wire__1aIh2","even-flash":"top-christmas_even-flash__37NQr","odd-flash":"top-christmas_odd-flash__3vC7b"};